import { computed } from 'vue'
import { useApiStore } from '../stores/apiStore.js'

/**
 * Prices Composable
 * Bietet Zugriff auf Preis-Daten mit Relations
 */
export function usePrices() {
  const apiStore = useApiStore()

  return {
    // Data
    prices: computed(() => apiStore.prices),
    
    // States
    loading: computed(() => apiStore.pricesLoading),
    error: computed(() => apiStore.pricesError),
    hasPrices: computed(() => apiStore.hasPrices),
    
    // Getters
    getByApartmentSlug: (slug) => apiStore.getPricesByApartmentSlug(slug),
    getByApartmentId: (apartmentId) => apiStore.getPricesByApartmentId(apartmentId),
    
    // Actions
    load: () => apiStore.loadPrices(),
    
    // Utility
    findByApartmentSlug: computed(() => (slug) => apiStore.getPricesByApartmentSlug(slug)),
    findByApartmentId: computed(() => (apartmentId) => apiStore.getPricesByApartmentId(apartmentId))
  }
}